import React ,{useState,useEffect} from 'react'
import { useNavigate,useParams,useLocation } from 'react-router-dom'
import campaignService from '../../services/campaign.service'
import Loading from '../common/Loading';
import { DataGrid } from '@mui/x-data-grid';
function CampaignQueue() {
    let { state } = useLocation();
    const {campaignId} = useParams();
    const [resultStat,setResultStat] = useState(null)
    const [result,setResult] = useState(null)
    const [rowCount,setRowCount] = useState(50)
    const [paginationModel,setPaginationModel] = useState({
      page:0,
      pageSize:50,
   })
    const columns = [
      {field:"id", headerName:"ID"},
      {field:"patientId", headerName:'Patient Id'},
     
      {field:"patientName",headerName:'Name',width:'200'},
      {field:"receiver",headerName:'Receiver',width:'220'},
      {field:"sender",headerName:'Sender',width:'220'},
      {field:"status",headerName:'Status',width:'150',
      valueGetter:(params)=>{
        if(params.value === 0){
          return "Waiting"
        }
        if(params.value === 1){
          return "Sent"
        }
        if(params.value === 2){
          return "Sent"
        }
        if(params.value === 3){
            return "Failed"
          }
      }
    },
     
    ]
    useEffect(()=>{
        getCampaignResult(paginationModel.page,paginationModel.pageSize)
     },[paginationModel.page,paginationModel.pageSize])


   

    const getCampaignResult = (pg,pgsize)=>{
        campaignService.getCampaignQueue(campaignId,pg,pgsize)
        .then(res=>{
            setResult(res.data.content)
            setRowCount(res.data.totalElements)
        })
        .catch(err=>{
            console.log(err)
        })
    }
    const getStatus = (id)=>{
      let retVal = ""
      switch (id) {
          case 0:
              retVal="Pending"
              break;
          case 1:
              retVal="In Process"
              break;
          case 2:
              retVal="Finished"
              break;
          case 3:
              retVal="Error"
              break
          default:
              retVal="Unknown"
              break;
      }
      return retVal
 }
  return (
   <>
     <div className="container container-xxl">
         <div className="pagetitle d-flex justify-content-between">
                  <h1>Campaign Queue</h1>
        </div>
        <div className="card">
          <div className="card-body p-4">
                <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                        <span><strong>Clinic Name : </strong>{state && state.info.clinicName}</span>
                        <span><strong>Name : </strong>{state && state.info.name}</span>
                        <span><strong>Title : </strong>{state && state.info.title}</span>
                    </div>
                    <div>
                    <span><strong>Current Status : {state && getStatus(state.info.status)}</strong></span>
                    </div>
                    <div className="d-flex flex-column">
                            <span><strong>Type : </strong> {state && state.info.type}</span>
                            <span><strong>Category : </strong>{state && state.info.category}</span>
                    </div>
                </div>
               
          </div>
        </div>
       
        <div className="row mt-3 p-3">
            <div className="col-12">
            <div style={{ width: '100%' }}>
            {result &&
                <DataGrid
                    rows={result}
                    rowCount={rowCount}
                    columns={columns}
                    pagination
                    paginationModel={paginationModel}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    paginationMode='server'
                    onPaginationModelChange={setPaginationModel}


                />
            }
                </div>
            </div>
               
        </div>
    </div>
   </>
  )
}

export default CampaignQueue